<template>
  <div class="question-wrapper" id="QuestionWraper">
    <Header
      :quiz="quiz"
      mode="embed"
      v-bind:class="getStartQuestion.start && getStartQuestion.time < quiz.settings.script.limitTime && !check_finish ? 'start-quiz' : ''"
    />
    <div v-if="parseInt(quiz.settings.script.limitTime) > 0">
      <LimitTime v-if="!getStartQuestion.start && !check_finish" :timeLimit="totalTime" />
      <div
        class="time"
        v-if="getStartQuestion.start && getStartQuestion.time < quiz.settings.script.limitTime && !check_finish"
      >
        <div class="total-time">
          <div class="current-time" v-bind:style="{ 'width': ratio }" />
        </div>
        <p class="txt-current-time">{{timeCurrent}}</p>
      </div>

      <Question
        :questions="questions"
        :itemWidth="itemWidth"
        :column="column"
        v-if="getStartQuestion.start && getStartQuestion.time < quiz.settings.script.limitTime && !(check_finish && quiz.settings.script.displayStyle == 'stack')"
      />

      <div
        v-if="quiz.settings.script.displayStyle == 'stack' && getStartQuestion.start && getStartQuestion.time < quiz.settings.script.limitTime && !check_finish"
        class="btn"
      >
        <div
          class="btn-back"
          v-bind:class=" numQuestion >= 1 ? 'actice-back' : ''"
          @click="backQuestion"
        >
          <BackIcon />Quay lại
        </div>
        <div
          class="btn-next"
          v-bind:class="answer[numQuestion].num == questions[0].answers.length && questions[0].answers.length > 0 && numQuestion < countQuestions-1 ? 'active-next' : ''"
          @click="nextQuestion"
        >
          Tiếp theo
          <NextIcon />
        </div>
      </div>
    </div>
    <div v-else>
      <Question
        v-if="!(check_finish && quiz.settings.script.displayStyle == 'stack')"
        :questions="questions"
        :itemWidth="itemWidth"
        :column="column"
      />
      <div v-if="quiz.settings.script.displayStyle == 'stack' && !check_finish" class="btn">
        <div
          class="btn-back"
          v-bind:class=" numQuestion >= 1 ? 'actice-back' : ''"
          @click="backQuestion"
        >
          <BackIcon />Quay lại
        </div>
        <div
          v-if="numQuestion < countQuestions-1"
          class="btn-next"
          v-bind:class="answer[numQuestion].num == questions[0].answers.length && questions[0].answers.length > 0 && numQuestion < countQuestions-1 ? 'active-next' : ''"
          @click="nextQuestion"
        >
          Tiếp theo
          <NextIcon />
        </div>
        <div
          v-else
          class="btn-next"
          v-bind:class="answer[numQuestion].num == questions[0].answers.length && questions[0].answers.length > 0 && numQuestion < countQuestions ? 'active-next' : ''"
          @click="doneQuestion"
        >
          Hoàn thành
          <NextIcon />
        </div>
      </div>
    </div>
    <Result
      v-if="getStartQuestion.start && getStartQuestion.time == quiz.settings.script.limitTime || check_finish"
      :correct_result="correct_result"
      :quiz="quiz"
    />
  </div>
</template>

<script>
import Header from "./Header";
import Question from "./Question";
import LimitTime from "./LimitTime";
import Result from "./Result";
import BackIcon from "../../ui/icons/svgs/icons/BackIcon";
import NextIcon from "../../ui/icons/svgs/icons/NextIcon";
import calculateSize from "@/common/calculate-size";
import ResizeObserverPolyfill from "resize-observer-polyfill";

export default {
  name: "Main",
  components: {
    Header,
    Question,
    LimitTime,
    Result,
    NextIcon,
    BackIcon
  },
  data: function() {
    return {
      currentTime: parseInt(this.$store.getters.quiz.settings.script.limitTime),
      totalTime: parseInt(this.$store.getters.quiz.settings.script.limitTime),
      ratio: "100%",
      itemWidth: 0,
      column: 0
    };
  },
  created() {
    setInterval(() => {
      if (this.currentTime > 0 && this.$store.getters.getStartQuiz) {
        this.currentTime -= 1;
        this.ratio =
          ((this.currentTime * 100) / this.totalTime).toFixed(2) + "%";
        this.$store.dispatch("updateTimePassed");
      }
    }, 1000);
  },
  computed: {
    quiz: function() {
      return this.$store.getters.quiz;
    },
    getStartQuestion: function() {
      return {
        start: this.$store.getters.getStartQuiz,
        time: this.$store.getters.getTimePassed
      };
    },
    answer: function() {
      return this.$store.getters.defaultAnswer;
    },
    numQuestion: function() {
      return this.$store.getters.getNumQuestion;
    },
    countQuestions: function() {
      return this.$store.getters.quiz.questions.length;
    },
    questions: function() {
      if (this.$store.getters.quiz.settings.script.displayStyle == "list") {
        return this.$store.getters.quiz.questions;
      } else {
        return [
          this.$store.getters.quiz.questions[this.$store.getters.getNumQuestion]
        ];
      }
    },
    correct_result: function() {
      let num_correct = 0;
      let get_answers = this.$store.getters.getAnswer;
      this.$store.getters.quiz.questions.filter(function(value, key) {
        let num_answer = 0;
        value.answers.filter(function(x) {
          if (get_answers.length > 0 && get_answers[key].data.includes(x)) {
            num_answer += 1;
          }
        });
        if (num_answer == value.answers.length) {
          num_correct += 1;
        }
      });
      return num_correct;
    },
    check_finish: function() {
      const finish = this.$store.getters.getFinish;
      const doneClick = this.$store.getters.getDoneClick;

      if (
        this.quiz.settings.script.displayStyle == "stack" &&
        finish == this.$store.getters.quiz.questions.length &&
        doneClick
      ) {
        return true;
      } else if (
        this.quiz.settings.script.displayStyle != "stack" &&
        finish == this.$store.getters.quiz.questions.length
      ) {
        return true;
      }
      return false;
    },
    timeCurrent: function() {
      if (this.currentTime > 0) {
        const minus =
          Math.floor(this.currentTime / 60) < 10
            ? "0" + Math.floor(this.currentTime / 60)
            : Math.floor(this.currentTime / 60);
        const seconds =
          this.currentTime - minus * 60 < 10
            ? "0" + (this.currentTime - minus * 60)
            : this.currentTime - minus * 60;
        if (minus > 0) {
          return "Còn " + minus + " phút " + seconds + " giây";
        } else {
          return "Còn " + seconds + " giây";
        }
      }
    },
    doneClick: function() {
      return this.$store.getters.getDoneClick;
    }
  },
  methods: {
    nextQuestion() {
      this.$store.dispatch("nextQuestion");
    },
    backQuestion() {
      this.$store.dispatch("backQuestion");
    },
    doneQuestion() {
      this.$store.dispatch("doneQuestion");
    }
  },
  mounted() {
    const calSize = () => {
      const size = calculateSize("#QuestionWraper", 150);
      this.itemWidth = size.width - 15 / size.col - 15;
      this.column = size.col;
    };
    const resizeObserver = new ResizeObserverPolyfill(() => {
      calSize();
    });
    resizeObserver.observe(document.querySelector("#QuestionWraper"));
  }
};
</script>

<style lang="scss">
@import "~@/styles/main.scss";
</style>